import { render } from "./AffectationLivreurModal.vue?vue&type=template&id=20152be0&ts=true"
import script from "./AffectationLivreurModal.vue?vue&type=script&lang=ts"
export * from "./AffectationLivreurModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__